import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { FilterCircleFill } from "react-bootstrap-icons";
import { useGetAllCategories } from "../api";
import CustomTreeSelect from "../../Common/CustomTreeSelect";
import { findTitleById } from "../utils";
const sortArrayOfObjects = (arr, key, asc) => {
  return arr.sort((a, b) => {
    if (asc) {
      return a[key].toLowerCase() > b[key].toLowerCase() ? 1 : -1;
    } else {
      return a[key].toLowerCase() < b[key].toLowerCase() ? 1 : -1;
    }
  });
};

export default function MenuMixTable({
  reports,
  setReports,
  handleCategoryChange,
  approveLoading,
  restaurant_id
}) {
  const [editableCell, setEditableCell] = useState(null);
  const [sort, setSort] = useState(false);
  const [category, setCategory] = useState(null);
  const [subcategory, setSubcategory] = useState(null);
  const [approveId, setApproveId] = useState(null);

  const { data: categories, isLoading, isError } = useGetAllCategories({
    restaurant_id,
  });
  if (!reports || reports.length === 0) {
    return <p>No reports available</p>;
  }
  const oheaders = Object.keys(reports[0]).filter(
    (key) =>
      key !== "_id" &&
      key !== "category_fasttext" &&
      key !== "category_bilstm" &&
      key !== "category_bert" &&
      key !== "item_uuid" &&
      key !== "pos_id"
  );

  // if oheaders doesn't have subcategory and subcategory_confidence, add them
  if (!oheaders.includes("subcategory")) {
    oheaders.push("subcategory");
  }
  if (!oheaders.includes("subcategory_confidence")) {
    oheaders.push("subcategory_confidence");
  }
  if (!oheaders.includes("sub_subcategory")) {
    oheaders.push("sub_subcategory");
  }
  if (!oheaders.includes("sub_subcategory_confidence")) {
    oheaders.push("sub_subcategory_confidence");
  }

  oheaders.push("Approve");

  const desiredOrder = [
    "pos_category_name",
    "Menu Item",
    "Approve",
    "category",
    "category_confidence",
    "subcategory",
    "subcategory_confidence",
    "sub_subcategory",
    "sub_subcategory_confidence",
    "BiLSTM Prediction",
    "Human Verified",
  ];

  // Filter the headers based on the desired order
  const headers = desiredOrder.filter((header) => oheaders.includes(header));

  const handleEditClick = (e, id) => {
    setEditableCell(id);
  };

  const handleEditableCellBlur = (
    id,
    cat,
    subcategory_id = null,
    sub_subcategory_id = null
  ) => {
    const body = {
      pmix_id: id,
      category_id: cat,
      restaurant_id:restaurant_id
    };
    if (subcategory_id) {
      body["sub_category_id"] = subcategory_id;
    }
    if (sub_subcategory_id) {
      body["sub_subcategory_id"] = sub_subcategory_id;
    }
    setEditableCell(null);
    handleCategoryChange(body);
  };
  const handleApprove = (
    id,
    category,
    subcategory_id = null,
    sub_subcategory_id = null
  ) => {
    const body = {
      pmix_id: id,
      category_id: category,
      restaurant_id:restaurant_id
    };
    if (subcategory_id) {
      body["sub_category_id"] = subcategory_id;
    }
    if (sub_subcategory_id) {
      body["sub_subcategory_id"] = sub_subcategory_id;
    }
    handleCategoryChange(body);
  };

  let categoryList = [
    {
      name: "Food",
      children: [],
    },
    {
      name: "Gift Card",
      children: [],
    },
    {
      name: "Merchandise",
      children: [],
    },
    {
      name: "Non-Alcoholic Beverage",
      children: [],
    },
    {
      name: "Beer",
      children: [
        {
          name: "Draft Beer",
          children: [],
        },
        {
          name: "Bottled Beer",
          children: [],
        },
      ],
    },
    {
      name: "Liquor",
      children: [],
    },
    {
      name: "Wine",
      children: [
        {
          name: "Wine Glass",
          children: [],
        },
        {
          name: "Wine Bottle",
          children: [],
        },
      ],
    },
  ];

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="table table-striped table-hover table-bordered shadow-sm table-responsive table-stack">
        <thead>
          <tr>
            {headers?.map((header) => (
              <th
                key={header}
                style={{
                  textAlign: "center",
                  textTransform: "capitalize",
                  verticalAlign: "middle",
                }}
              >
                {header
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (l) => l.toUpperCase())}
                {header === "pos_category_name" && (
                  <FilterCircleFill
                    fill={sort ? "blue" : "black"}
                    style={{
                      cursor: "pointer",
                      marginLeft: "5px",
                    }}
                    onClick={(e) => {
                      if (sort) {
                        setReports(sortArrayOfObjects(reports, header, true));
                        setSort(false);
                      } else {
                        setReports(sortArrayOfObjects(reports, header, false));
                        setSort(true);
                      }
                    }}
                  />
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {reports?.map((row) => (
            <React.Fragment key={row.item_uuid}>
              <tr>
                {headers?.map((header) => (
                  <td
                    data-label={header.replace(/_/g, " ")}
                    style={{
                      textAlign: "center",
                      textTransform: "capitalize",
                    }}
                    key={header}
                    onClick={(e) => {
                      handleEditClick(e, row._id);
                      setCategory(row.category);
                      setSubcategory(row.subcategory);
                    }}
                  >
                    {editableCell === row._id && header == "category" ? (
                      <div
                        style={{
                          position: "absolute",
                        }}
                      >
                        <CustomTreeSelect
                          value={findTitleById(
                            categories?.categories?.filter(
                              (item) => item.type === "Menu" &&
                              !item.is_manual
                            ),
                            row[header]
                          )}
                          data={categories?.categories.filter(
                            (item) =>
                              item.type === "Menu" &&
                              item.title !== "Default" &&
                              item.title !== "Service" &&
                              !item.is_manual
                          )}
                          placeholder="Select Category"
                          onChange={(item, hierarchy) => {
                            if (hierarchy.length === 1) {
                              handleEditableCellBlur(row._id, hierarchy[0]);
                            } else if (hierarchy.length === 2) {
                              handleEditableCellBlur(
                                row._id,
                                hierarchy[0],
                                hierarchy[1]
                              );
                            } else if (hierarchy.length === 3) {
                              handleEditableCellBlur(
                                row._id,
                                hierarchy[0],
                                hierarchy[1],
                                hierarchy[2]
                              );
                            }
                          }}
                        />
                      </div>
                    ) : typeof row[header] === "boolean" ? (
                      row[header] ? (
                        "Yes"
                      ) : (
                        "No"
                      )
                    ) : header == "Approve" ? (
                      approveLoading && approveId === row._id ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          variant="primary"
                        />
                      ) : row["Human Verified"] === true ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="green"
                          class="bi bi-check-circle-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="blue"
                          class="bi bi-hand-thumbs-up-fill"
                          viewBox="0 0 16 16"
                          onClick={() => {
                            setApproveId(row._id);
                            handleApprove(
                              row._id,
                              row.category,
                              row.subcategory,
                              row.sub_subcategory
                            );
                          }}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z" />
                        </svg>
                      )
                    ) : header === "category" ||
                      header === "subcategory" ||
                      header === "sub_subcategory" ? (
                      <>
                        {findTitleById(
                          categories &&
                            categories?.categories?.filter(
                              (item) => item?.type === "Menu"
                            ),
                          row[header]
                        )}
                      </>
                    ) : header === "BiLSTM Prediction" ? (
                      <>{row[header]}</>
                    ) : (
                      row[header]
                    )}
                  </td>
                ))}
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
